import { Image } from "@graphcommerce/image";
import Link from "next/link";
import { ProductWidgetsType } from "../../../../api/landingPage/widgets";
import { Money } from "../../../Money";
import MainContentLayout from "../../../customLayout/mainContentLayout";
import IconBellOutline from "../../../icons/IconBellOutline";





export default function DiscountWidgets(widgetsData: any) {
  const widgets = [
    {
      title: 'تخفیف دار ترین ها',
      data: widgetsData?.widgetsData?.data?.mostDiscountedWidget
    }
  ]

  return (
    <MainContentLayout className="md:!mt-10 box-border" homeLayout>
      {widgets.map((item, index) => (
        <div key={item.title} className={`${index > 0 && 'mt-10'}`}>
          <div className="border-dashed border-t-[1px] border-t-default-400 w-full items-start justify-start ">
            <h3 className=" flex flex-row items-center text-default-400 font-semibold text-xl bg-white w-[200px] -mt-[15px]"> <IconBellOutline width={30} height={30} />{item.title}</h3>
          </div>

          <div className="w-full flex flex-wrap gap-4 max-w-[100%] justify-center mt-3">

            {item?.data?.slice(0, 6)?.map((product: ProductWidgetsType) => (
              <div key={product?.id} className="bg-white relative sm:w-full md:max-w-[355px] w-full min-w-[300px] shadow-md border border-solid border-light-50 flex flex-row items-stretch p-2 rounded-lg overflow-hidden">
                <Link href={`/p/${product?.url_key}`} className="h-[120px] w-[120px] relative flex items-center justify-center">
                  <Image width={100} height={100} src={product?.image?.url} alt="" />
                </Link>

                <div className="pr-2 relative fade-content">
                  < Link href={`/p/${product?.url_key}`} className="w-full h-full fade-content flex flex-col justify-around " >
                    <p className="text-sm text-default-900">
                      {product?.name}
                    </p>
                    <div className="w-full flex justify-start items-center mt-3 gap-6">

                      <span className="text-sm text-light-400 line-through">
                        {product?.price_range?.minimum_price?.discount?.percent_off > 0 && <Money showCurrency={false} {...product?.price_range?.minimum_price?.regular_price} />}
                      </span>
                      <span className="text-base text-secondary-500 font-semibold ml-1">
                        <Money {...product?.price_range?.minimum_price?.final_price} />
                      </span>
                    </div>
                  </Link>
                </div>
                {product?.price_range?.minimum_price?.discount?.percent_off > 0 &&
                  <span className="w-8 h-8 bg-secondary-500 absolute left-0 top-0 text-center text-xs text-white flex items-center justify-center  rounded-br-full">
                    %{Math.round(product?.price_range?.minimum_price?.discount?.percent_off)}
                  </span>}
              </div>
            ))}

          </div>

        </div>
      ))}

    </MainContentLayout>

  )
}